import { FieldArray, useField, useFormikContext } from "formik";
import React from "react";
import { DeleteButton } from "../button/Delete.Button";
import { AddTitle } from "../components/common/Add.title";
import { EBButton } from "../components/common/EBButton";
import { FormikInputParams } from "../components/common/input/FormikInputParams.model";
import { SocialTypeSelector } from "../components/common/input/SocialType.selector";
import { EBTextInputV2 } from "../components/common/input/TextLine.input";
import { SocialLink, SocialType } from "./Social.model";
import { detectSocialTypeIdFromUrl, resolveSocialType } from "./social.utils";

interface SocialLinksInputProps extends FormikInputParams {
  allSocialTypes: SocialType[];
}

export function SocialLinksInput(props: SocialLinksInputProps) {
  const [field] = useField(props);
  const { setFieldValue } = useFormikContext();
  const currentLinks: SocialLink[] = field.value ?? [];

  function handleUrlChange(index: number, url: string) {
    // EBTextInputV2 already calls field.onChange to keep the URL in Formik state.
    // Only auto-detect and set the type if the user hasn't already chosen one.
    if (currentLinks[index]?.type) return;

    const detectedId = detectSocialTypeIdFromUrl(url, props.allSocialTypes);
    if (detectedId !== null) {
      const resolved = resolveSocialType(detectedId, props.allSocialTypes);
      if (resolved) {
        setFieldValue(`${props.name}.${index}.type`, resolved);
      }
    }
  }

  return (
    <div className="SocialLinksInput">
      <FieldArray name={`${props.name}`}>
        {({ remove, push }: any) => (
          <>
            {currentLinks.map((socialLink, index) => (
              <div className="row mb-2" key={index}>
                <div className="col">
                  <EBTextInputV2
                    required={true}
                    name={`${props.name}.${index}.url`}
                    placeholder="A valid URL. Example: https://enginebogie.com/u/username"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      handleUrlChange(index, e.target.value)
                    }
                  />
                </div>
                <div className="col">
                  <SocialTypeSelector
                    required={true}
                    socialTypes={props.allSocialTypes}
                    name={`${props.name}.${index}.type`}
                  />
                </div>

                <div className="col-auto px-0">
                  <DeleteButton onClick={() => remove(index)} />
                </div>
              </div>
            ))}

            <EBButton
              classes={["btn btn-secondary btn-sm"]}
              type="button"
              text={{ normal: <AddTitle text="Add" /> }}
              onClick={() => {
                push({});
              }}
            />
          </>
        )}
      </FieldArray>
    </div>
  );
}
